import { NewBuildingSearchRoute } from '@search/nb-routes/src/NewBuildingSearchRoute';
import { NewBuildingSearchMapRoute } from '@search/nb-routes/src/NewBuildingSearchMapRoute';

import initBrowserApp from '../../../../client/common/libs/init-browser-app';
import NotFoundPage from '../../../../client/desktop/components/NotFoundPage';

import instanceConfig from '../../config';

import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';

import { linkBuilder } from '../../routes/routes';
import NewBuildingSearchPage from '../../../../client/desktop/components/NewBuildingSearchPage';
import NewBuildingSearchPageSeo from '../../../../client/common/components/NewBuildingSearchPageSeo';
import NewBuildingSearchMapPage from '../../../../client/desktop/components/NewBuildingSearchMapPage';
import NewBuildingSearchMapPageSeo from '../../../../client/common/components/NewBuildingSearchMapPageSeo';

import '../../components/common/styles.css';
import '../../components/desktop/styles.css';

initBrowserApp({
    routes: [
        {
            type: 'NewBuildingSearchRoute',
            route: NewBuildingSearchRoute,
            Component: NewBuildingSearchPage,
            SeoComponent: NewBuildingSearchPageSeo
        },
        {
            type: 'NewBuildingSearchMapRoute',
            route: NewBuildingSearchMapRoute,
            Component: NewBuildingSearchMapPage,
            SeoComponent: NewBuildingSearchMapPageSeo
        }
    ],
    linkBuilder,
    instanceConfig,
    components: {
        Header,
        Footer,
        NotFoundPage
    }
});

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition,@typescript-eslint/strict-boolean-expressions,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
// @ts-ignore
if (typeof module.hot === 'object') {
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition,@typescript-eslint/strict-boolean-expressions,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
    module.hot.accept();
}
